<template>
  <CRow>
    <CCol col="12" lg="8">
      <CCard>
        <CCardHeader>
          <strong>Προσθήκη πελάτη τιμολογίου</strong>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <template slot="header">
              Προσθήκη πελάτη τιμολογίου
            </template>
            <CModal
              class="modalAlert"
              :show.sync="alertIsShown"
              :centered="true"
              size="lg"
            >
              <CAlert
                closeButton
                :show.sync="alertIsShown"
                color="primary"
                fade
              >
                {{ message }}
              </CAlert>
            </CModal>
              
              <CInput horizontal type="text" label="Κωδικός*" id="client_code" placeholder="Κωδικός" v-model="client_code" :disabled='disabledCode'></CInput>
              <CInput horizontal type="text" label="Επωνυμία Εταιρίας*" id="company" placeholder="Επωνυμία Εταιρίας*" v-model="company"></CInput>
              <CInput label="Υπεύθυνος Επικοινωνίας*" type="text" id="name" placeholder="Υπεύθυνος Επικοινωνίας" v-model="name" horizontal></CInput>
              <CInput horizontal type="text" label="Διεύθυνση" id="address" placeholder="Διεύθυνση" v-model="address"></CInput>
              <CInput horizontal type="text" label="Πόλη" id="town" placeholder="Πόλη" v-model="town"></CInput>
              <CInput horizontal type="text" label="Νομός" id="state" placeholder="Νομός" v-model="state"></CInput>
              <CInput horizontal type="text" label="Ταχυδρομικός Κώδικας" id="postcode" placeholder="Ταχυδρομικός Κώδικας" v-model="postcode"></CInput>
              <CInput horizontal type="text" label="Τηλέφωνο" id="phone_number_1" placeholder="Τηλέφωνο" v-model="phone_number_1"></CInput>
              <CInput horizontal type="text" label="ΑΦΜ*" id="afm" placeholder="ΑΦΜ" v-model="afm"></CInput>
              <CInput horizontal type="text" label="ΔΟΥ" id="doy" placeholder="ΔΟΥ" v-model="doy"></CInput>

              <CButton color="primary" @click="store()">Δημιουργία</CButton>
              <CButton color="primary" @click="goBack">Πίσω</CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CreateInvoiceClient',
  props: {
    caption: {
      type: String,
      default: 'Create Invoice Client'
    },
  },
  data: () => {
    return {
        client_code: '',
        name: '',
        afm: '',
        doy: '',
        address: '',
        town: '',
        state: '',
        postcode: '',
        phone_number_1: '',
        company: '',
        alertIsShown: false,
        disabledCode: true,
        showMessage: false,
        message: '',
        dismissSecs: 7,
        dismissCountDown: 0,
        showDismissibleAlert: false
    }
  },
  computed: {
    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    store() {
        let self = this;
        axios.post('/api/invoiceclients?token=' + localStorage.getItem("api_token"),
        {
          client_code: self.client_code,
          name: self.name,
          afm: self.afm,
          doy: self.doy,
          address: self.address,
          town: self.town,
          state: self.state,
          postcode: self.postcode,
          phone_number_1: self.phone_number_1,
          company: self.company,
        })
        .then(function (response) {
            self.client_code = '';
            self.name = '';
            self.afm = '';
            self.doy = '';
            self.address = '';
            self.town = '';
            self.state = '';
            self.postcode = '';
            self.phone_number_1 = '';
            self.company = '';
            self.message = 'Επιτυχής καταχώρηση πελάτη.';
            self.showAlert();
        }).catch(function (error) {
            if(error.response.data.message == 'The given data was invalid.'){
              self.message = '';
              for (let key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key)) {
                  self.message += error.response.data.errors[key][0] + '  ';
                }
              }
              self.showAlert();
            }else{
              console.log(error.response.data.message);
              console.log(error);
              self.$router.push({ path: 'login' }); 
            }
        });
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
  },
  mounted: function() {
    const characters ='abcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for ( let i = 0; i < 7; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    this.client_code = 'ΠΕΛ'+result;
  }
}

</script>
